<div #ccySelector class="order___footer__button__bar__allocations__toggle">
  <button
    pButton
    *ngFor="let item of model"
    (click)="onSelectPair(item)"
    class="bfx-button-sm"
    [ngClass]="{'bfx-button-secondary-moderate': item !== activeItem, 'bfx-button-primary-bold': item === activeItem }"
  >
    {{item}}
  </button>
</div>
